import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/en/knowledge-center/glossary")({
  component: () => <Outlet />,
});
